import { _ as Mt, b as Tt, d as $t, g as kt, h as Bt, l as ot, m as De, p as Ft, y as Nt } from "./layout-BD1t4ofR.js";
import { n as b } from "./Logger-CmiOOsKC.js";
import { C as _t, S as Rt, _ as Pt, g as zt, h as It, m as Ce, p as jt, u as Ot, v as Ut, w as Dt, x as Ct, y as Lt } from "./tracebehavior-5_qSKjs6.js";
import { d as Gt, f as Vt, g as Be, h as at, wt as Wt } from "./SceneCreation-DVCYLXYF.js";
import { i as Kt } from "./AnimationUtils-Dau2PA8x.js";
import { $ as Ht, H as Jt, X as Le } from "./ScriptRegistry-C3vqndus.js";
import { f as qt } from "./properties-C_pgb9zu.js";
import { S as it, a as Qt, m as Yt, y as Xt } from "./AssetTypes-DUDo9FdH.js";
import { l as Zt, n as er, s as Ge, t as Fe } from "./morphstretch-YfBvUhFE.js";
import { t as tr } from "./imageanchor-DusNzbVp.js";
import { t as rr } from "./text-CeJQaWao.js";
import { r as nr } from "./textBody-DYKq_GsW.js";
import { _ as ye, a as ct, d as sr, i as lt, m as re, n as Ve, s as or, v as We, y as ie } from "./TraceScene-CTdK35pV.js";
import { t as ar } from "./abort-qw0xAdg5.js";
import { c as Te, i as ft } from "./GltfSceneLoaderPlugin-g47wYMf3.js";
import { _ as Ke, a as dt, c as ir, d as ut, i as cr, l as lr, m as se, o as fr, p as He, r as ht, s as dr, t as Se, v as ur } from "./types-CzLXLofj.js";
import { n as hr, t as gr } from "./zipAnchorConversion-B_49vmUS.js";
import { r as pr } from "./ImageMarkerLoader-aTenj78C.js";
import { n as mr, r as gt, t as yr } from "./exportFilters-BQ5JaJJo.js";
import { t as br } from "./settle-BdkUrROl.js";
import { Matrix as le, Quaternion as wr, Vector3 as q } from "@babylonjs/core/Maths/math.vector.js";
import { Mesh as Ne } from "@babylonjs/core/Meshes/mesh.js";
import { VertexData as xr } from "@babylonjs/core/Meshes/mesh.vertexData.js";
import { GLTF2Export as vr } from "@babylonjs/serializers";
import { SubMesh as pt } from "@babylonjs/core/Meshes/subMesh.js";
import { VertexBuffer as P } from "@babylonjs/core/Buffers/buffer.js";
import { MultiMaterial as Sr } from "@babylonjs/core/Materials/multiMaterial.js";
import { RandomGUID as Ar } from "@babylonjs/core/Misc/guid.js";
var Je = (e) => e.transform?.parent ? `${e.transform.parent}/${e.name}` : e.name, Ae = (e, t, r) => {
  const n = e.transform?.parent;
  return n ? n === r || n === t.name || n.endsWith(`/${t.name}`) : !1;
};
function Er(e, t, r, n, s, o) {
  const a = n?.getBehavior(Jt)?.getPageNodes();
  if (a) {
    const f = a.map((d) => s.get(d));
    return f.every((d) => d !== void 0) ? f : null;
  }
  if ((o.get(e.name) ?? 0) > 1) return null;
  const i = Je(e);
  if (t.pageSource === "firstChild") {
    const f = r.find((d) => Ae(d, e, i));
    return f ? r.filter((d) => Ae(d, f, Je(f))) : [];
  }
  const l = new Set((t.shared ?? []).map((f) => f.split("/").pop()));
  return r.filter((f) => Ae(f, e, i) && !l.has(f.name));
}
function Mr(e, t) {
  const r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  for (const o of e) {
    n.set(o.name, (n.get(o.name) ?? 0) + 1);
    const a = t?.get(o);
    a?.transform && r.set(a.transform, o);
  }
  let s = 0;
  for (const o of e) {
    const a = o.behaviors?.find((l) => l["@type"] === "Pages");
    if (!a) continue;
    const i = Er(o, a, e, t?.get(o), r, n);
    !i || i.length === 0 || i.some((l) => typeof l.active == "string") || (i.forEach((l, f) => {
      l.active = f === 0;
    }), s += 1);
  }
  return s;
}
var Tr = [
  {
    match: /wood|plank|bark|timber|parquet/i,
    config: {
      tileSize: 2,
      sharpness: 2
    }
  },
  {
    match: /fabric|carpet|denim|knit|linen|canvas|basket|cork/i,
    config: {
      tileSize: 3,
      sharpness: 2.5
    }
  },
  {
    match: /stone|marble|granite|slate|terrazzo|gravel/i,
    config: {
      tileSize: 1.5,
      sharpness: 2
    }
  },
  {
    match: /concrete|conrete|cardboard/i,
    config: {
      tileSize: 1,
      sharpness: 2
    }
  },
  {
    match: /brick|\broofs?(?![a-z])|\btiles?(?![a-z])/i,
    config: {
      tileSize: 2.5,
      sharpness: 2
    }
  }
];
function mt(...e) {
  for (const t of e) {
    if (!t) continue;
    let r = t;
    try {
      r = decodeURIComponent(t);
    } catch {
    }
    const n = (r.split("/").pop() ?? r).replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/_/g, " "), s = Tr.find((o) => o.match.test(n));
    if (s) return s.config;
  }
  return null;
}
var yt = Object.freeze({
  tileSize: 1,
  sharpness: 2
});
function _e(e) {
  return !!(e.albedoTexture || e.bumpTexture || e.metallicTexture);
}
function bt(e, ...t) {
  return !e || e.getClassName() !== "PBRMaterial" || !_e(e) ? null : mt(...t) ?? yt;
}
function wt(e, ...t) {
  const r = e?.metadata?.gltf?.extras?.trace?.triplanar;
  if (r == null) return null;
  if (r === !1) return !1;
  const n = mt(...t, e?.name) ?? yt;
  if (r === !0) return n;
  if (typeof r != "object") return null;
  const s = r, o = (a, i, l) => typeof a == "number" && Number.isFinite(a) && a >= l ? a : i;
  return {
    tileSize: o(s.tileSize, n.tileSize, Number.MIN_VALUE),
    sharpness: o(s.sharpness, n.sharpness, 0)
  };
}
function Hn(e, ...t) {
  const r = wt(e, ...t);
  return r === !1 ? null : r ? !e || e.getClassName() !== "PBRMaterial" ? null : _e(e) ? r : null : bt(e, ...t);
}
function $r(e, t, ...r) {
  if (!e) return null;
  const n = Nr(e), s = wt(e, ...r);
  if (s === !1) return null;
  if (s)
    return !(e.getClassName() === "PBRMaterial" && _e(e)) && !n ? null : {
      config: s,
      anchor: t
    };
  if (n) return {
    config: {
      tileSize: n.tileSize,
      sharpness: n.sharpness
    },
    anchor: n.anchorNode
  };
  const o = bt(e, ...r);
  return o ? {
    config: o,
    anchor: t
  } : null;
}
var kr = "TriplanarPBRPlugin", Br = new q(), qe = new wr(), Qe = new q(), Fr = le.Identity();
function xt(e, t, r) {
  e.getWorldMatrix().decompose(Br, qe, Qe);
  const n = r ?? Fr;
  le.ComposeToRef(q.OneReadOnly, qe, Qe, n), n.invertToRef(t);
}
var Ye = le.Identity(), Xe = le.Identity();
function Jn(e, t, r, n) {
  xt(e, r, n), !(!t || t === e || t.isDisposed()) && (t.getWorldMatrix().invertToRef(Ye), Ye.multiplyToRef(e.getWorldMatrix(), Xe), Xe.multiplyToRef(r, r), n && r.invertToRef(n));
}
function Nr(e) {
  const t = e?.pluginManager?.getPlugin(kr);
  return !t?.isEnabled || !t.texture && !t.normalTexture && !t.ormTexture ? null : {
    tileSize: t.tileSize,
    sharpness: t.sharpness,
    anchorNode: t.anchorNode ?? null
  };
}
var R = 1e4;
function _r(e, t, r, n) {
  if (e.length % 3 !== 0) throw new Error(`toNonIndexed: positions must be whole vec3s, got length ${e.length}`);
  if (t.length !== e.length) throw new Error(`toNonIndexed: normals length ${t.length} != positions length ${e.length}`);
  if (r && r.length / 2 !== e.length / 3) throw new Error(`toNonIndexed: uvs length ${r.length} does not match ${e.length / 3} vertices`);
  if (n && n.length % 3 !== 0) throw new Error(`toNonIndexed: indices must be triangles (length % 3 === 0), got ${n.length}`);
  if (!n) {
    if (e.length % 9 !== 0) throw new Error(`toNonIndexed: unindexed positions must be whole triangles (length % 9 === 0), got ${e.length}`);
    return {
      positions: e.slice(),
      normals: t.slice(),
      uvs: r ? r.slice() : null,
      triCount: e.length / 9
    };
  }
  const s = n.length, o = new Float32Array(s * 3), a = new Float32Array(s * 3), i = r ? new Float32Array(s * 2) : null;
  for (let l = 0; l < s; l++) {
    const f = n[l];
    o[l * 3] = e[f * 3], o[l * 3 + 1] = e[f * 3 + 1], o[l * 3 + 2] = e[f * 3 + 2], a[l * 3] = t[f * 3], a[l * 3 + 1] = t[f * 3 + 1], a[l * 3 + 2] = t[f * 3 + 2], i && r && (i[l * 2] = r[f * 2], i[l * 2 + 1] = r[f * 2 + 1]);
  }
  return {
    positions: o,
    normals: a,
    uvs: i,
    triCount: s / 3
  };
}
function Rr(e, t, r) {
  if (e.length % 9 !== 0) throw new Error(`computeTangents: positions must be unindexed triangles (length % 9 === 0), got ${e.length}`);
  if (t.length !== e.length) throw new Error(`computeTangents: normals length ${t.length} != positions length ${e.length}`);
  if (r.length / 2 !== e.length / 3) throw new Error(`computeTangents: uvs length ${r.length} does not match ${e.length / 3} vertices`);
  const n = e.length / 3, s = n / 3, o = new Int32Array(n), a = /* @__PURE__ */ new Map();
  let i = 0;
  for (let c = 0; c < n; c++) {
    const u = Math.round(e[c * 3] * R) + "_" + Math.round(e[c * 3 + 1] * R) + "_" + Math.round(e[c * 3 + 2] * R) + "_" + Math.round(t[c * 3] * R) + "_" + Math.round(t[c * 3 + 1] * R) + "_" + Math.round(t[c * 3 + 2] * R) + "_" + Math.round(r[c * 2] * R) + "_" + Math.round(r[c * 2 + 1] * R);
    let h = a.get(u);
    h === void 0 && (h = i++, a.set(u, h)), o[c] = h;
  }
  const l = new Float32Array(i * 3), f = new Float32Array(i * 3);
  for (let c = 0; c < s; c++) {
    const u = 3 * c, h = 3 * c + 1, g = 3 * c + 2, w = e[h * 3] - e[u * 3], M = e[h * 3 + 1] - e[u * 3 + 1], k = e[h * 3 + 2] - e[u * 3 + 2], m = e[g * 3] - e[u * 3], y = e[g * 3 + 1] - e[u * 3 + 1], S = e[g * 3 + 2] - e[u * 3 + 2], $ = r[h * 2] - r[u * 2], E = r[h * 2 + 1] - r[u * 2 + 1], F = r[g * 2] - r[u * 2], I = r[g * 2 + 1] - r[u * 2 + 1], A = $ * I - F * E;
    if (Math.abs(A) < 1e-12) continue;
    const T = 1 / A, U = (I * w - E * m) * T, W = (I * M - E * y) * T, L = (I * k - E * S) * T, Q = ($ * m - F * w) * T, H = ($ * y - F * M) * T, p = ($ * S - F * k) * T;
    for (let x = 0; x < 3; x++) {
      const v = o[3 * c + x];
      l[v * 3] += U, l[v * 3 + 1] += W, l[v * 3 + 2] += L, f[v * 3] += Q, f[v * 3 + 1] += H, f[v * 3 + 2] += p;
    }
  }
  const d = new Float32Array(n * 4);
  for (let c = 0; c < n; c++) {
    const u = o[c], h = t[c * 3], g = t[c * 3 + 1], w = t[c * 3 + 2], M = l[u * 3], k = l[u * 3 + 1], m = l[u * 3 + 2], y = h * M + g * k + w * m;
    let S = M - h * y, $ = k - g * y, E = m - w * y;
    const F = Math.hypot(S, $, E);
    if (F > 1e-9)
      S /= F, $ /= F, E /= F;
    else {
      const W = Math.abs(h), L = Math.abs(g), Q = Math.abs(w);
      let H = 0, p = 0, x = 0;
      W <= L && W <= Q ? H = 1 : L <= Q ? p = 1 : x = 1, S = p * w - x * g, $ = x * h - H * w, E = H * g - p * h;
      const v = Math.hypot(S, $, E) || 1;
      S /= v, $ /= v, E /= v;
    }
    const I = g * m - w * k, A = w * M - h * m, T = h * k - g * M, U = I * f[u * 3] + A * f[u * 3 + 1] + T * f[u * 3 + 2] < 0 ? -1 : 1;
    d[c * 4] = S, d[c * 4 + 1] = $, d[c * 4 + 2] = E, d[c * 4 + 3] = U;
  }
  return d;
}
function Pr(e) {
  if (e.positions.length % 3 !== 0) throw new Error(`weldByAttributes: positions must be whole vec3s, got length ${e.positions.length}`);
  const t = e.positions.length / 3;
  if (e.normals.length !== e.positions.length) throw new Error(`weldByAttributes: normals length ${e.normals.length} != positions length ${e.positions.length}`);
  if (e.uvs.length / 2 !== t) throw new Error(`weldByAttributes: uvs length ${e.uvs.length} does not match ${t} vertices`);
  if (e.tangents && e.tangents.length / 4 !== t) throw new Error(`weldByAttributes: tangents length ${e.tangents.length} does not match ${t} vertices`);
  const r = e.tangents !== void 0, n = new Uint32Array(t), s = /* @__PURE__ */ new Map(), o = [], a = [], i = [], l = [];
  let f = 0;
  for (let c = 0; c < t; c++) {
    let u = Math.round(e.positions[c * 3] * R) + "_" + Math.round(e.positions[c * 3 + 1] * R) + "_" + Math.round(e.positions[c * 3 + 2] * R) + "_" + Math.round(e.normals[c * 3] * R) + "_" + Math.round(e.normals[c * 3 + 1] * R) + "_" + Math.round(e.normals[c * 3 + 2] * R) + "_" + Math.round(e.uvs[c * 2] * R) + "_" + Math.round(e.uvs[c * 2 + 1] * R);
    if (r) {
      const g = e.tangents;
      u += "_" + Math.round(g[c * 4] * R) + "_" + Math.round(g[c * 4 + 1] * R) + "_" + Math.round(g[c * 4 + 2] * R) + "_" + Math.round(g[c * 4 + 3] * R);
    }
    let h = s.get(u);
    if (h === void 0 && (h = f++, s.set(u, h), o.push(e.positions[c * 3], e.positions[c * 3 + 1], e.positions[c * 3 + 2]), a.push(e.normals[c * 3], e.normals[c * 3 + 1], e.normals[c * 3 + 2]), i.push(e.uvs[c * 2], e.uvs[c * 2 + 1]), r)) {
      const g = e.tangents;
      l.push(g[c * 4], g[c * 4 + 1], g[c * 4 + 2], g[c * 4 + 3]);
    }
    n[c] = h;
  }
  const d = {
    indices: n,
    positions: new Float32Array(o),
    normals: new Float32Array(a),
    uvs: new Float32Array(i)
  };
  return r && (d.tangents = new Float32Array(l)), d;
}
var zr = 1, Ir = 4;
function Ze(e) {
  return e >> 1;
}
function et(e) {
  return e & 1 ? -1 : 1;
}
function jr(e, t, r, n, s) {
  const { scale: o, method: a = "routed", iterations: i = 8 } = s;
  if (e.length % 9 !== 0) throw new Error(`buildProjectedUV: positions must be unindexed triangles (length % 9 === 0), got ${e.length}`);
  if (t.length !== e.length) throw new Error(`buildProjectedUV: normals length ${t.length} != positions length ${e.length}`);
  const l = e.length / 3, f = l / 3, d = 6, c = new Float32Array(l * 3), u = new Float32Array(l * 3), h = new q(), g = new q();
  for (let p = 0; p < l; p++)
    h.set(e[p * 3], e[p * 3 + 1], e[p * 3 + 2]), q.TransformCoordinatesToRef(h, r, h), c[p * 3] = h.x, c[p * 3 + 1] = h.y, c[p * 3 + 2] = h.z, g.set(t[p * 3], t[p * 3 + 1], t[p * 3 + 2]), q.TransformNormalToRef(g, n, g), g.normalize(), u[p * 3] = g.x, u[p * 3 + 1] = g.y, u[p * 3 + 2] = g.z;
  const w = new Int32Array(l), M = /* @__PURE__ */ new Map(), k = [];
  let m = 0;
  for (let p = 0; p < l; p++) {
    const x = e[p * 3], v = e[p * 3 + 1], B = e[p * 3 + 2], N = Math.round(x * R) + "_" + Math.round(v * R) + "_" + Math.round(B * R);
    let _ = M.get(N);
    _ === void 0 && (_ = m++, M.set(N, _), k.push(x, v, B)), w[p] = _;
  }
  const y = new Float32Array(f * 3), S = new Float32Array(f), $ = new Float32Array(f * d), E = new Uint8Array(f);
  for (let p = 0; p < f; p++) {
    const x = 3 * p, v = 3 * p + 1, B = 3 * p + 2, N = c[v * 3] - c[x * 3], _ = c[v * 3 + 1] - c[x * 3 + 1], z = c[v * 3 + 2] - c[x * 3 + 2], j = c[B * 3] - c[x * 3], O = c[B * 3 + 1] - c[x * 3 + 1], D = c[B * 3 + 2] - c[x * 3 + 2];
    let C = _ * D - z * O, J = z * j - N * D, Y = N * O - _ * j;
    const K = Math.hypot(C, J, Y);
    S[p] = 0.5 * K, K > 0 && (C /= K, J /= K, Y /= K), y[p * 3] = C, y[p * 3 + 1] = J, y[p * 3 + 2] = Y;
    let X = u[x * 3] + u[v * 3] + u[B * 3], Z = u[x * 3 + 1] + u[v * 3 + 1] + u[B * 3 + 1], ne = u[x * 3 + 2] + u[v * 3 + 2] + u[B * 3 + 2];
    const ee = Math.hypot(X, Z, ne);
    ee > 0 && (X /= ee, Z /= ee, ne /= ee);
    const fe = [
      X,
      Z,
      ne
    ];
    let oe = 0, ae = 1 / 0;
    for (let G = 0; G < d; G++) {
      const de = Ze(G), ue = et(G), te = 1 - Math.max(0, ue * fe[de]);
      $[p * d + G] = te, te < ae && (ae = te, oe = G);
    }
    E[p] = oe;
  }
  const F = /* @__PURE__ */ new Map(), I = (p, x, v) => {
    const B = Math.min(p, x), N = Math.max(p, x), _ = B + "_" + N;
    let z = F.get(_);
    if (!z) {
      const j = k[B * 3] - k[N * 3], O = k[B * 3 + 1] - k[N * 3 + 1], D = k[B * 3 + 2] - k[N * 3 + 2];
      z = {
        tris: [],
        len: Math.hypot(j, O, D)
      }, F.set(_, z);
    }
    z.tris.push(v);
  };
  for (let p = 0; p < f; p++) {
    const x = w[3 * p], v = w[3 * p + 1], B = w[3 * p + 2];
    I(x, v, p), I(v, B, p), I(B, x, p);
  }
  const A = Array.from({ length: f }, () => []);
  for (const p of F.values()) {
    if (p.tris.length !== 2) continue;
    const [x, v] = p.tris, B = y[x * 3] * y[v * 3] + y[x * 3 + 1] * y[v * 3 + 1] + y[x * 3 + 2] * y[v * 3 + 2], N = p.len * Math.pow(Math.max(0, B), Ir);
    A[x].push({
      j: v,
      w: N
    }), A[v].push({
      j: x,
      w: N
    });
  }
  if (a === "routed") for (let p = 0; p < i; p++) {
    let x = 0;
    for (let v = 0; v < f; v++) {
      const B = A[v];
      let N = E[v], _ = 1 / 0;
      for (let z = 0; z < d; z++) {
        let j = $[v * d + z];
        for (let O = 0; O < B.length; O++) E[B[O].j] !== z && (j += zr * B[O].w);
        j < _ && (_ = j, N = z);
      }
      N !== E[v] && (E[v] = N, x++);
    }
    if (x === 0) break;
  }
  const T = new Float32Array(l * 2);
  for (let p = 0; p < f; p++) {
    const x = E[p], v = Ze(x), B = et(x);
    for (let N = 0; N < 3; N++) {
      const _ = 3 * p + N, z = c[_ * 3] * o, j = c[_ * 3 + 1] * o, O = c[_ * 3 + 2] * o;
      let D, C;
      v === 0 ? (D = j, C = O * B) : v === 1 ? (D = z * B, C = O) : (D = z * B, C = j), T[_ * 2] = D, T[_ * 2 + 1] = C;
    }
  }
  let U = 0, W = 0, L = 0;
  for (let p = 0; p < f; p++) {
    const x = 3 * p, v = 3 * p + 1, B = 3 * p + 2;
    let N = c[v * 3] - c[x * 3], _ = c[v * 3 + 1] - c[x * 3 + 1], z = c[v * 3 + 2] - c[x * 3 + 2];
    const j = Math.hypot(N, _, z) || 1e-9;
    N /= j, _ /= j, z /= j;
    const O = c[B * 3] - c[x * 3], D = c[B * 3 + 1] - c[x * 3 + 1], C = c[B * 3 + 2] - c[x * 3 + 2], J = O * N + D * _ + C * z;
    let Y = O - N * J, K = D - _ * J, X = C - z * J;
    const Z = Math.hypot(Y, K, X) || 1e-9;
    Y /= Z, K /= Z, X /= Z;
    const ne = O * Y + D * K + C * X, ee = T[v * 2] - T[x * 2], fe = T[v * 2 + 1] - T[x * 2 + 1], oe = T[B * 2] - T[x * 2], ae = T[B * 2 + 1] - T[x * 2 + 1], G = j * ne;
    let de = o, ue = o;
    if (Math.abs(G) > 1e-12) {
      const Pe = ne / G, ze = -J / G, Ie = 0, je = j / G, be = ee * Pe + oe * Ie, we = ee * ze + oe * je, xe = fe * Pe + ae * Ie, ve = fe * ze + ae * je, he = be * be + we * we + xe * xe + ve * ve, Oe = be * ve - we * xe, Ue = Math.sqrt(Math.max(0, he * he - 4 * Oe * Oe));
      de = Math.sqrt(Math.max(0, (he + Ue) / 2)), ue = Math.sqrt(Math.max(0, (he - Ue) / 2));
    }
    const te = Math.max(de / o, o / Math.max(ue, 1e-9)), Re = S[p];
    W += te * Re, U += Re, te > L && (L = te);
  }
  let Q = 0, H = 0;
  for (const p of F.values())
    p.tris.length !== 2 || E[p.tris[0]] === E[p.tris[1]] || (Q += p.len, H++);
  return {
    uv: T,
    stretchStats: {
      avg: U ? W / U : 1,
      max: L
    },
    seamStats: {
      edges: H,
      length: Q
    }
  };
}
function V(e) {
  return re.removeAssetsPrefix(e);
}
var Or = {
  Provenance: /* @__PURE__ */ new Set(["placedFrom", "remixOf"]),
  Text: /* @__PURE__ */ new Set(["text"])
};
function tt(e, t) {
  const r = e["@type"];
  return typeof r == "string" && (Or[r]?.has(t) ?? !1);
}
var rt = class {
  resourceManager;
  _liveByRecord = /* @__PURE__ */ new WeakMap();
  _reuseBakesFrom;
  _propertySheets = /* @__PURE__ */ new Map();
  _changedPropertySheets = /* @__PURE__ */ new Set();
  liveObjectFor(e) {
    return this._liveByRecord.get(e);
  }
  constructor() {
    this.resourceManager = new re();
  }
  async prepareSceneContent(e, t, r, n) {
    return {
      content: await this.prepareExport(e, t, void 0, r, n),
      assets: new Map(this.resourceManager.getAssetEntries()),
      propertySheets: this._propertySheets,
      changedPropertySheets: this._changedPropertySheets
    };
  }
  resolveAsset(e, t) {
    if (!t || !e) return [void 0, void 0];
    if (se(e) || ie(e)) return [void 0, void 0];
    if (e.startsWith("builtin:")) return [void 0, void 0];
    const r = t.getAsset(e);
    return r ? (b.log(`[TraceExport] Found blob using declared src: ${e}`), [r, e]) : t.resolveAssetUrl(e) ? (b.debug(`[TraceExport] Folder file already in its folder, no local blob: ${e}`), [void 0, void 0]) : (b.error(`[TraceExport] Could not find blob for declared src: ${e}`), [void 0, void 0]);
  }
  processAssetForNode(e, t, r, n) {
    if (n && t) {
      const a = re.removeAssetsPrefix(t);
      this.resourceManager.addAsset(a, n), e.src = `./assets/${a}`, b.log(`[TraceExport] Added preloaded blob to assets: ${a}`);
      return;
    }
    const [s, o] = this.resolveAsset(t, r);
    if (s && o) {
      const a = re.removeAssetsPrefix(o);
      this.resourceManager.addAsset(a, s), e.src = `./assets/${a}`, b.log(`[TraceExport] Added asset blob to assets: ${a}`);
    } else e.src = t;
  }
  extractBehaviorAssets(e, t) {
    if (!t || !e) return;
    const r = (n) => {
      if (We(n)) {
        const [s, o] = this.resolveAsset(n, t);
        if (s && o) {
          const a = re.removeAssetsPrefix(o);
          this.resourceManager.addAsset(a, s), b.log(`[TraceExport] Extracted behavior asset: ${a}`);
        }
      } else if (Array.isArray(n)) n.forEach((s) => r(s));
      else if (n && typeof n == "object") {
        const s = n;
        for (const [o, a] of Object.entries(s)) ye(s, o) || r(a);
      }
    };
    e.forEach(r);
  }
  exportHierarchy(e, t, r) {
    if (t) {
      let n, s;
      if (r?.subtreeRoots?.length) {
        const o = t._buildExportDataForSubtrees(r.subtreeRoots, r.groupRootName);
        n = o.data, s = o.sceneObjects;
      } else if (r?.subtreeRoot) {
        const o = t._buildExportDataForSubtree(r.subtreeRoot);
        n = o.data, s = o.sceneObjects;
      } else if (r?.includeRoot !== !1) {
        const o = t._buildDocumentExportData();
        n = o.data, s = o.sceneObjects;
      } else {
        const o = t._buildExportData();
        n = o.data, s = o.sceneObjects, Ve.stripSceneRootPrefix(n);
        const a = t.getSessionDocumentRoot(), i = a ? s.indexOf(a) : -1;
        i >= 0 && (Ve.stripSceneRootPrefix(n, n[i].name), n.splice(i, 1), s.splice(i, 1));
      }
      if (r?.exclude) {
        const o = lt(n, s, r.exclude);
        n = o.data, s = o.liveObjects;
      }
      for (let o = 0; o < n.length; o++) {
        const a = s[o];
        a && this._liveByRecord.set(n[o], a);
      }
      for (const o of n) Gr(o);
      return this.processAssets(n, s, t), n;
    } else {
      const n = [], s = [];
      return e.transformNodes.forEach((o) => {
        !o.parent && o.name != "Render Bounds" && (b.log(`Serializing root node: ${o.name}`), s.push(o));
      }), this.processLayer(s, n), n;
    }
  }
  processAssets(e, t, r) {
    const n = r.resources, s = (i) => se(i) || ie(i), o = /* @__PURE__ */ new Set();
    for (let i = 0; i < e.length; i++) {
      const l = t[i], f = e[i].src;
      l && s(f) && Vt(f) && o.add(l);
    }
    const a = /* @__PURE__ */ new Set();
    for (let i = 0; i < e.length; i++) {
      const l = t[i];
      if (!l) continue;
      const f = l.getParent();
      f && o.has(f) && (a.add(i), o.add(l));
    }
    for (let i = 0; i < e.length; i++) {
      const l = e[i], f = t[i];
      if (!a.has(i)) {
        if (l.src && this.processAssetForNode(l, l.src, n), f) {
          const d = f.getBehavior(Le);
          if (d) {
            let c = d.sceneObject.src;
            const u = l.behaviors?.find((h) => h["@type"] === "VideoPlayer" || h["@type"] === "Video");
            if (u) {
              const h = u.src;
              h && (c = h);
            }
            this.processAssetForNode(l, c, n);
          } else {
            const c = f.getBehavior(Ge);
            if (c) {
              const u = c.sceneObject.src;
              this.processAssetForNode(l, u, n);
            }
          }
        }
        l.behaviors && this.extractBehaviorAssets(l.behaviors, n);
      }
    }
  }
  processLayer(e, t) {
    const r = [];
    e.forEach((n) => {
      const s = n.metadata;
      b.log(`[TraceExport] Serializing node: ${n.name}, behaviors: ${n.behaviors?.length || 0}, metadata components: ${s?.length || 0}`);
      const o = n.parent?.name, a = o && o !== n.name ? o : void 0, i = {
        name: n.name,
        src: void 0,
        active: n.isEnabled(!1),
        transform: {
          translation: n.position.asArray(),
          rotation: n.rotationQuaternion?.asArray(),
          scale: n.scaling.asArray(),
          parent: a
        },
        behaviors: []
      };
      let l = !0;
      i.behaviors = s ? [...s] : [], s && s.length > 0 && b.log(`[TraceExport] Copied ${s.length} components from metadata for ${n.name}`);
      for (const f of n.behaviors) if (f instanceof Le) {
        i.src = f.sceneObject.src;
        const d = i.behaviors.find((u) => u["@type"] === "VideoPlayer" || u["@type"] === "Video"), c = d ? d.src : void 0;
        c && (i.src = c), l = !1;
      } else f instanceof Ge ? (i.src = f.sceneObject.src, l = !1) : f instanceof Zt ? l = !1 : f instanceof Wt ? b.log(`Serializing animation behavior for ${n.name}`) : f instanceof Be && b.log(`Serializing renderer behavior for ${n.name}`);
      if (b.log(`[TraceExport] Final serialized node ${n.name}:`, {
        src: i.src,
        componentsCount: i.behaviors.length,
        hasParent: !!i.transform?.parent
      }), t.push(i), l) {
        const f = n.getChildTransformNodes(!0);
        b.log(`[TraceExport] Node ${n.name} has ${f.length} children, will recurse`), f.forEach((d) => {
          d != null && r.push(d);
        });
      } else
        b.log(`[TraceExport] Skipping recursion for node: ${n.name}`), b.log(`Skipping recursion for node: ${n.name}`);
    }), r.length > 0 && (b.log(`[TraceExport] Processing next layer with ${r.length} nodes`), this.processLayer(r, t));
  }
  serializeBehavior(e) {
    return e.serialize();
  }
  collectExternalUrls(e) {
    const t = /* @__PURE__ */ new Set(), r = (n) => !n || typeof n != "string" ? !1 : ie(n) ? !0 : se(n);
    for (const n of ge(e)) {
      r(n.src) && t.add(n.src);
      for (const s of Object.keys(n))
        tt(n, s) || ye(n, s) || r(n[s]) && t.add(n[s]);
    }
    return t;
  }
  async downloadAsset(e) {
    try {
      b.log(`[TraceExport] Downloading asset: ${e}`);
      const t = await fetch(e);
      if (!t.ok)
        return b.warn(`[TraceExport] Failed to download ${e}: ${t.status}`), null;
      const r = await t.arrayBuffer(), n = t.headers.get("content-type");
      if (it(e, n, r))
        return b.warn(`[TraceExport] Failed to download ${e}: it answered with a web page, not an asset`), null;
      const s = new Blob([r], { type: n ?? "" });
      return b.log(`[TraceExport] Downloaded ${e} (${s.size} bytes)`), s;
    } catch (t) {
      return b.error(`[TraceExport] Error downloading ${e}:`, t), null;
    }
  }
  getFilenameFromUrl(e, t = "bin") {
    const r = () => `asset_${Math.random().toString(36).substring(2, 15)}.${t}`;
    try {
      const n = new URL(e, "http://local").pathname, s = n.substring(n.lastIndexOf("/") + 1);
      return !s || !s.includes(".") ? r() : s;
    } catch {
      return r();
    }
  }
  rewriteUrls(e, t) {
    for (const r of ge(e)) for (const n of Object.keys(r)) {
      if (tt(r, n) || ye(r, n)) continue;
      const s = r[n];
      typeof s == "string" && t.has(s) && (b.log(`[TraceExport] Rewriting ${n}: ${s} -> ${t.get(s)}`), r[n] = t.get(s));
    }
  }
  async prepareExport(e, t, r, n, s) {
    const o = s?.bundleExternalAssets ?? !0;
    this._reuseBakesFrom = s?.reuseUnchangedBakes && n ? {
      resources: n.resources,
      folderUrl: s.reuseUnchangedBakes.folderUrl
    } : void 0;
    const a = !!r, i = this.exportHierarchy(e, n, {
      includeRoot: !a,
      subtreeRoot: s?.subtreeRoot,
      subtreeRoots: s?.subtreeRoots,
      groupRootName: s?.groupRootName,
      exclude: s?.exclude
    });
    for (const y of i) ur(y.transform, y.name);
    Mr(i, this._liveByRecord), this._propertySheets = dt(i, (y) => this._liveByRecord.get(y));
    const l = s?.imageMarker, f = l ?? !!pr(n)?.getBehavior(tr);
    a && f ? nn(i) : a && l === void 0 && b.warn("[TraceExport] .zip frame decided by runtime fallback: no ImageAnchor found, exporting WITHOUT the anchor-frame conversion. If this scene is image-anchored in the CMS, pass `imageMarker` (from `isSceneAnchored(scene)`)."), await this.bakeBevelNodes(i, e), await this.bakeTextBodies(i, e), s?.bake && await this.bakeDeformedNodes(i, e), b.log("[TraceExport] Collecting built-in primitives...");
    const d = $t(i);
    if (b.log(`[TraceExport] Found ${d.size} built-in primitives to generate`), d.size > 0) {
      const y = Array.from(d).map(async (S) => {
        b.log(`[TraceExport] Generating GLB for primitive: ${S}`);
        const $ = await Bt(S, e), E = ot[S];
        this.resourceManager.addAsset(E, $), b.log(`[TraceExport] Added primitive GLB: ${E} (${$.size} bytes)`);
      });
      await Promise.all(y), b.log(`[TraceExport] Generated ${d.size} primitive GLBs`), b.log("[TraceExport] Rewriting builtin paths to local paths..."), Tt(i), Ft(i);
    }
    const c = n?.resources, u = [...this._propertySheets.values()].flatMap((y) => fr(y).map((S) => S.value));
    this.extractBehaviorAssets(u, c), b.log("[TraceExport] Collecting external URLs...");
    const h = this.collectExternalUrls([i, u]), g = o ? h : new Set([...h].filter((y) => ie(y)));
    b.log(o ? `[TraceExport] Found ${g.size} external URLs to download` : `[TraceExport] Preserving remote URLs (bundleExternalAssets=false); bundling ${g.size} site-absolute asset(s)`);
    const w = /* @__PURE__ */ new Map();
    if (g.size > 0) {
      const y = Array.from(g).map(async (S) => {
        const $ = this._propertySheets.get(S), E = c?.getAsset(S) ?? ($ ? new Blob([JSON.stringify($)], { type: "application/json" }) : void 0), F = E ?? await this.downloadAsset(S);
        if (F) {
          const I = Yt(F.type) ?? (await Xt(F) ? "glb" : void 0), A = await this.resourceManager.addAssetWithDedup(this.getFilenameFromUrl(S, I), F);
          w.set(S, `./assets/${A}`), b.log(`[TraceExport] Mapped ${S} -> ./assets/${A}${E ? " (from cache)" : ""}`);
        }
      });
      await Promise.all(y), b.log(`[TraceExport] Downloaded ${w.size} assets successfully`), b.log("[TraceExport] Rewriting URLs to local paths..."), this.rewriteUrls(i, w);
    }
    this.writePropertySheets(w);
    const M = (/* @__PURE__ */ new Date()).toISOString();
    let k;
    if (n?.scriptsMap) {
      k = n.scriptsMap;
      for (const y of Object.values(k)) {
        const S = n.resources.getAsset(y);
        if (S) {
          const $ = re.removeAssetsPrefix(y);
          this.resourceManager.addAsset($, S);
        }
      }
    }
    const m = {
      sceneName: t,
      version: "2.0.0",
      content: i.map(Ur),
      ...k && { scripts: k },
      generator: `This file was generated by the Trace Sandbox Exporter on ${M}.`
    };
    return r ? this.resourceManager.setJson(m, r) : this.resourceManager.setJson(m), i;
  }
  writePropertySheets(e) {
    const t = /* @__PURE__ */ new Map();
    this._changedPropertySheets = /* @__PURE__ */ new Set();
    for (const [r, n] of this._propertySheets) {
      const s = e.get(r) ?? r, o = dr(n, e);
      o !== n && this._changedPropertySheets.add(V(s)), t.set(s, o);
      const a = V(s);
      We(s) && (o !== n || !this.resourceManager.getAsset(a)) && this.resourceManager.addAsset(a, new Blob([JSON.stringify(o)], { type: "application/json" }));
    }
    this._propertySheets = t;
  }
  async _settleBake(e, t, r) {
    const n = `./assets/${t}`, s = this._reuseBakesFrom;
    if (!e || !s || !r) return n;
    const o = Rt(e), a = this.resourceManager.getAsset(t);
    return o && a && await Cr(a, await Dr(s.resources, o)) ? (Lt(e, r), o) : (Ct(e, `assets/${t}`, r), n);
  }
  _unchangedBake(e) {
    const t = this._reuseBakesFrom;
    if (!e || !t) return;
    const { resources: r, folderUrl: n } = t;
    return Dt(e, (s) => n ? r.storedUriIn(n, s) : void 0);
  }
  async bakeBevelNodes(e, t) {
    const r = /* @__PURE__ */ new Set(), n = async (s) => {
      const o = s.src;
      if (typeof o != "string") return;
      let a = null;
      const i = Mt(o);
      if (i === "cube" || i === "plane") a = i;
      else {
        const u = /(?:^|\/)(?:bevel|primitive)_(cube|plane)(?:_[0-9a-f]{8})?\.glb$/.exec(o);
        u && (a = u[1]);
      }
      if (!a) return;
      const l = (Array.isArray(s.behaviors) ? s.behaviors : []).find((u) => u && u["@type"] === "Bevel");
      if (!l) return;
      const f = this._liveByRecord.get(s), d = f && Ce(f);
      let c = this._unchangedBake(f);
      if (!c) {
        const u = s.transform?.scale ?? [
          1,
          1,
          1
        ], h = Ht(l, u, a);
        if (!h) return;
        const g = ce(`${a}|r${(l.cornerRadius ?? 0).toFixed(6)}|p${l.pill ? 1 : 0}|a${l.axis ?? "auto"}|e${l.edges ?? "corners"}|s${u.map((M) => M.toFixed(5)).join(",")}`), w = zt(a, g);
        if (!r.has(w)) {
          r.add(w);
          const M = await De(h, w.replace(".glb", ""), t);
          this.resourceManager.addAsset(w, M), b.log(`[TraceExport] Baked Bevel geometry: ${w} (${M.size} bytes)`);
        }
        c = await this._settleBake(f, w, d);
      }
      pe(s, kt(a), (u) => !!this.resourceManager.getAsset(V(u))), s.src = c, Array.isArray(s.behaviors) && (s.behaviors = s.behaviors.filter((u) => u?.["@type"] !== "Model"));
    };
    for (const s of ge(e)) await n(s);
  }
  async bakeTextBodies(e, t) {
    const r = /* @__PURE__ */ new Set();
    for (const n of ge(e)) {
      const s = this._liveByRecord.get(n)?.getBehavior(rr);
      if (!s || It(n.src, n.behaviors) === "") continue;
      if (n.src) {
        s.isExtruded() && b.warn(`[TraceExport] "${String(n.name)}" has its own src; its extruded text body is not baked`);
        continue;
      }
      const o = await s.buildBody();
      if (!o) {
        s.isExtruded() && b.warn(`[TraceExport] "${String(n.name)}" has depth but no body to bake (nothing to outline, or its outlines did not load); it saves as flat text`);
        continue;
      }
      const { geometry: a, color: i } = o, l = _t(ce(`${a.positions.map((f) => f.toFixed(6)).join(",")}|${a.indices.join(",")}|${i.toHexString()}`));
      if (!r.has(l)) {
        r.add(l);
        const f = new xr();
        f.positions = a.positions, f.normals = a.normals, f.indices = a.indices;
        const d = l.replace(".glb", ""), c = await De(f, d, t, { material: (u) => nr(`${d}_material`, u, i) });
        this.resourceManager.addAsset(l, c), b.log(`[TraceExport] Baked text body: ${l} (${c.size} bytes)`);
      }
      pe(n, Ot, () => !1), n.src = `./assets/${l}`, Array.isArray(n.behaviors) && (n.behaviors = n.behaviors.filter((f) => f?.["@type"] !== "Model"));
    }
  }
  async bakeDeformedNodes(e, t) {
    const r = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), s = Date.now() + at, o = async (a) => {
      if (!Yr(a.behaviors)) return;
      const i = this._liveByRecord.get(a);
      if (!i?.transform) return;
      const l = Ce(i), f = this._unchangedBake(i);
      if (f && typeof a.src == "string" && new ke(i).projections.size === 0) {
        pe(a, a.src, (c) => !!this.resourceManager.getAsset(V(c))), a.src = f;
        return;
      }
      const d = await At(i, s);
      try {
        const c = new ke(i, n);
        if (!c.hasWork) return;
        if (typeof a.src != "string" || !a.src) {
          b.warn(`[TraceExport] "${typeof a.name == "string" ? a.name : "?"}" carries baked geometry (${Vr(c)}) but no src — skipping bake, so it publishes at rest`);
          return;
        }
        const u = c.exported.filter((g) => g instanceof Ne), h = Pt(ce(Kr(a.src, c, u)));
        if (!r.has(h)) try {
          c.bake();
          const g = c.exportedSet;
          gt(`TraceExport bake ${h}`, c.excludedHelpers);
          const w = await vt(t, h, g);
          this.resourceManager.addAsset(h, w), r.add(h), b.log(`[TraceExport] Baked morph-deformed geometry: ${h} (${w.size} bytes)`);
        } finally {
          c.restore();
        }
        pe(a, a.src, (g) => !!this.resourceManager.getAsset(V(g))), a.src = await this._settleBake(i, h, l);
      } finally {
        await d();
      }
    };
    for (const a of e) await o(a);
  }
  async exportScene(e, t, r, n, s) {
    return await this.prepareExport(e, t, r, n, s), n && await this.bakeLegacyGlbRoots(n, s?.subtreeRoot, s?.exclude), this.resourceManager.createTraceBlob(s?.onProgress);
  }
  async bakeLegacyGlbRoots(e, t, r) {
    const n = ct(t ? [t, ...t.getDescendants()] : e.getSceneObjects(), r).filter((a) => a._resetAssetTransform && a.src);
    if (n.length === 0) return;
    const { bakeGlbRootIdentity: s } = await import("./glbRootBake-C5BhDtA1.js"), o = /* @__PURE__ */ new Set();
    for (const a of n) {
      const i = re.removeAssetsPrefix(a.src);
      if (o.has(i)) continue;
      o.add(i);
      const l = this.resourceManager.getAsset(i) ?? this.resourceManager.getAsset(`assets/${i}`);
      if (!l) continue;
      const f = s(new Uint8Array(await l.arrayBuffer()));
      f && this.resourceManager.addAsset(i, new Blob([f.slice().buffer]));
    }
  }
};
function Ur(e) {
  if (e.uid === void 0 && e.animationBinding === void 0) return e;
  const { uid: t, animationBinding: r, ...n } = e;
  return n;
}
function ge(e) {
  const t = [], r = (n) => {
    if (!n || typeof n != "object") return;
    const s = n;
    t.push(s);
    for (const o of Object.keys(s))
      ye(s, o) || r(s[o]);
  };
  for (const n of e) r(n);
  return t;
}
async function Dr(e, t) {
  const r = e.getAsset(t) ?? e.getAsset(t.replace(/^\.\//, ""));
  if (r) return r;
  const n = e.resolveAssetUrl(t);
  if (n)
    try {
      const s = await fetch(n);
      return s.ok ? await s.blob() : void 0;
    } catch (s) {
      b.warn(`[TraceExport] could not read ${t} to compare a re-bake with it`, s);
      return;
    }
}
async function Cr(e, t) {
  if (!t || e.size !== t.size) return !1;
  const [r, n] = await Promise.all([e.arrayBuffer(), t.arrayBuffer()]), s = new Uint8Array(r), o = new Uint8Array(n);
  return s.every((a, i) => a === o[i]);
}
async function vt(e, t, r) {
  const n = /* @__PURE__ */ new Set();
  for (const s of e.animationGroups) for (const o of s.targetedAnimations) Kt(o.target, r) || n.add(o.animation);
  return await Lr(r), (await vr.GLBAsync(e, t, {
    exportWithoutWaitingForScene: !0,
    shouldExportNode: (s) => r.has(s),
    shouldExportAnimation: (s) => !n.has(s),
    exportUnusedUVs: !0
  })).glTFFiles[t];
}
async function Lr(e, t = 1e4) {
  const r = /* @__PURE__ */ new Set();
  for (const o of e) {
    const a = o.material, i = a instanceof Sr ? a.subMaterials : [a];
    for (const l of i) for (const f of l?.getActiveTextures() ?? []) r.add(f);
  }
  const n = Date.now() + t;
  let s = [...r].filter((o) => !o.isReady());
  for (; s.length > 0; ) {
    if (Date.now() >= n) {
      b.warn(`[TraceExport] bake: ${s.length} texture(s) still loading after ${t} ms, writing without them: ${s.map((o) => o.name).join(", ")}`);
      return;
    }
    await new Promise((o) => setTimeout(o, 50)), s = s.filter((o) => !o.isReady());
  }
}
function ce(e) {
  let t = 2166136261;
  for (let r = 0; r < e.length; r++)
    t ^= e.charCodeAt(r), t = Math.imul(t, 16777619);
  return (t >>> 0).toString(16).padStart(8, "0");
}
function pe(e, t, r) {
  const n = Array.isArray(e.behaviors) ? e.behaviors : [], s = n.find((o) => o && o["@type"] === "Provenance");
  if (jt(t) !== "deformation") {
    if (!(Nt(t) || se(t) || r(t))) {
      b.warn(`[TraceExport] "${typeof e.name == "string" ? e.name : "?"}" baked from "${t}", which this export does not carry — publishing without a way back`);
      return;
    }
    if (s) {
      s.bakedFrom = t;
      return;
    }
    n.push({
      "@type": "Provenance",
      bakedFrom: t
    }), e.behaviors = n;
  }
}
function Gr(e) {
  if (Ut(e.src) || !e.behaviors) return;
  const t = [];
  for (const r of e.behaviors) {
    if (r["@type"] !== "Provenance" || !("bakedFrom" in r)) {
      t.push(r);
      continue;
    }
    const { bakedFrom: n, ...s } = r;
    Object.keys(s).some((o) => o !== "@type") && t.push(s);
  }
  e.behaviors = t;
}
function Vr(e) {
  const t = [];
  return e.morphed.length > 0 && t.push(`${e.morphed.length} morph-stretched mesh(es)`), e.projections.size > 0 && t.push(`${e.projections.size} triplanar projection(s)`), e.scaled.size > 0 && t.push(`${e.scaled.size} scale fold(s)`), t.join(", ") || "no work";
}
function St(e) {
  if (!e) return "-";
  try {
    const t = [e.getClassName()], r = e.subMaterials;
    if (Array.isArray(r)) for (const n of r) t.push(St(n ?? null));
    return t.push($e(e.serialize())), ce(t.join("~"));
  } catch (t) {
    return b.warn(`[TraceExport] material "${e.name}" did not serialize for the bake key; keying by identity`, t), `id:${e.uniqueId}`;
  }
}
function $e(e) {
  return e === null || typeof e != "object" ? JSON.stringify(e) ?? "null" : Array.isArray(e) ? `[${e.map($e).join(",")}]` : `{${Object.entries(e).filter(([t, r]) => r !== void 0 && !Wr.has(t)).sort(([t], [r]) => t < r ? -1 : t > r ? 1 : 0).map(([t, r]) => `${JSON.stringify(t)}:${$e(r)}`).join(",")}}`;
}
var Wr = /* @__PURE__ */ new Set(["uniqueId", "id"]);
function Kr(e, t, r) {
  const n = t.morphed.map((i) => {
    const l = i.morphTargetManager, f = [i.name];
    for (let d = 0; d < l.numTargets; d++) f.push(`${l.getTarget(d).name}:${l.getTarget(d).influence.toFixed(6)}`);
    return f.join(",");
  }).join(";"), s = [...t.projections].map(([i, l]) => l.ranges.map((f, d) => {
    if (!f.config) return "";
    const c = l.ranges.length > 1 ? `#${d}` : "";
    return `|tri1:${i.name}${c}:${f.config.tileSize}:${f.config.sharpness}:${ce(Array.from(f.projMatrix.m, (u) => Math.round(u * 1e5) / 1e5).join(","))}`;
  }).join("")).join(""), o = [...t.scaled.keys()].map((i) => {
    const l = i.scaling, f = (d) => Math.round(d * 1e5) / 1e5;
    return `|scl:${i.name}:${f(l.x)},${f(l.y)},${f(l.z)}`;
  }).join(""), a = r.map((i) => `${i.name}=${St(i.material)}`).sort().join(",");
  return e + "|" + n + s + o + "|mat:" + a;
}
function Hr(e) {
  const t = /* @__PURE__ */ new Map(), r = e.getBehavior(Be), n = r?.getOriginalMaterials();
  if (!r || !n) return t;
  const s = r.getMeshSlots();
  for (const [o, a] of Object.entries(n)) {
    const i = s.get(Number(o));
    i instanceof Ne && a && t.set(i, a);
  }
  return t;
}
var Jr = /* @__PURE__ */ new Set([
  P.PositionKind,
  P.NormalKind,
  P.UVKind,
  P.TangentKind
]), qr = /^(?:position|normal|tangent|color)\d+$|^(?:uv|uv2)_\d+$/, Qr = ["MorphStretch", "MeshBackground"];
function Yr(e) {
  return Array.isArray(e) && e.some((t) => !!t && typeof t == "object" && Qr.includes(String(t["@type"])));
}
function Xr(e) {
  return !!e.getBehavior(Fe) || !!e.getBehavior(er);
}
async function At(e, t) {
  const r = await e.getBehavior(Be)?.showBaseMaterialsForBake(t) ?? null;
  let n;
  try {
    n = e.getBehavior(Fe)?.showBaseSizeForBake() ?? null;
  } catch (s) {
    throw await r?.(), s;
  }
  return async () => {
    n?.(), await r?.();
  };
}
var ke = class {
  exported;
  exportedSet;
  excludedHelpers;
  morphed;
  projections;
  scaled;
  _candidates;
  _snapshots = [];
  constructor(e, t) {
    this.live = e, this.excludedHelpers = [], this.exported = mr(this.live, this.excludedHelpers), this.exportedSet = new Set(this.exported);
    const r = this.exported.filter((s) => s instanceof Ne && !s.isAnInstance && !t?.has(s));
    for (const s of r) t?.add(s);
    this._candidates = r, this.morphed = r.filter((s) => {
      const o = s.morphTargetManager;
      if (!o) return !1;
      for (let a = 0; a < o.numTargets; a++) if (Math.abs(o.getTarget(a).influence) > 1e-6) return !0;
      return !1;
    }), this.projections = Zr(r, this.live.transform, Hr(this.live));
    const n = this.live.getBehavior(Fe);
    if (this.scaled = /* @__PURE__ */ new Map(), n) for (const s of r) {
      const o = n.getRestScaling(s);
      if (!o) continue;
      const a = s.scaling;
      if (!(Math.abs(a.x - o.x) <= 1e-6 && Math.abs(a.y - o.y) <= 1e-6 && Math.abs(a.z - o.z) <= 1e-6)) {
        if (Math.abs(o.x) <= 1e-9 || Math.abs(o.y) <= 1e-9 || Math.abs(o.z) <= 1e-9) {
          b.warn(`[TraceExport] scalebake ${s.name}: degenerate rest scaling — skipping scale fold`);
          continue;
        }
        if (!(a.x > 1e-9) || !(a.y > 1e-9) || !(a.z > 1e-9)) {
          b.warn(`[TraceExport] scalebake ${s.name}: current scaling is zero, negative or NaN (${a.x}, ${a.y}, ${a.z}) — skipping scale fold`);
          continue;
        }
        this.scaled.set(s, {
          rest: o,
          factor: new q(a.x / o.x, a.y / o.y, a.z / o.z)
        });
      }
    }
  }
  get hasWork() {
    return this.morphed.length > 0 || this.projections.size > 0 || this.scaled.size > 0;
  }
  bake() {
    const e = new Set(this.morphed), t = [...this.morphed, ...this._candidates.filter((r) => !e.has(r) && (this.projections.has(r) || this.scaled.has(r)))];
    for (const r of t) {
      const n = r.geometry;
      if (!n) continue;
      const s = r.getVerticesData(P.PositionKind);
      if (!s) continue;
      const o = e.has(r) ? r.morphTargetManager : null;
      let a = null, i = null;
      if (o) {
        const d = r.getVerticesData(P.NormalKind);
        a = new Float32Array(s), i = d ? new Float32Array(d) : null;
        for (let c = 0; c < o.numTargets; c++) {
          const u = o.getTarget(c), h = u.influence;
          if (Math.abs(h) <= 1e-6) continue;
          const g = u.getPositions();
          if (g) for (let M = 0; M < a.length; M++) a[M] += h * (g[M] - s[M]);
          const w = i && u.hasNormals ? u.getNormals() : null;
          if (w && i && d) for (let M = 0; M < i.length; M++) i[M] += h * (w[M] - d[M]);
        }
        if (i) for (let c = 0; c < i.length; c += 3) {
          const u = i[c], h = i[c + 1], g = i[c + 2], w = Math.hypot(u, h, g) || 1;
          i[c] = u / w, i[c + 1] = h / w, i[c + 2] = g / w;
        }
      }
      this._snapshots.push({
        mesh: r,
        geometry: n,
        manager: r.morphTargetManager,
        scaling: r.scaling.clone(),
        subMeshes: r.subMeshes.map((d) => ({
          materialIndex: d.materialIndex,
          verticesStart: d.verticesStart,
          verticesCount: d.verticesCount,
          indexStart: d.indexStart,
          indexCount: d.indexCount
        }))
      }), n.copy(Ar()).applyToMesh(r), a && r.setVerticesData(P.PositionKind, a, !0), i && r.setVerticesData(P.NormalKind, i, !0);
      const l = this.projections.get(r), f = this.scaled.get(r);
      (o || (l || f) && r.morphTargetManager) && (r.morphTargetManager = null), l && tn(r, l), f && rn(r, f.rest, f.factor, this.exportedSet), r.refreshBoundingInfo();
    }
  }
  restore() {
    for (const e of this._snapshots) {
      const t = e.mesh.geometry;
      if (t !== e.geometry) {
        e.geometry.applyToMesh(e.mesh), t?.dispose(), e.mesh.releaseSubMeshes();
        for (const r of e.subMeshes) new pt(r.materialIndex, r.verticesStart, r.verticesCount, r.indexStart, r.indexCount, e.mesh);
      }
      e.mesh.morphTargetManager = e.manager, e.mesh.scaling.copyFrom(e.scaling), e.mesh.computeWorldMatrix(!0), e.mesh.refreshBoundingInfo(!1, !0);
    }
  }
};
function Zr(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  for (const s of e) {
    const o = s.subMeshes ?? [];
    if (o.length === 0) continue;
    const a = r?.get(s), i = o.map((d) => {
      const c = d.getMaterial(!1);
      return $r(c, t, c?.name, a);
    });
    if (!i.some((d) => d !== null)) continue;
    if (!s.isVerticesDataPresent(P.NormalKind)) {
      b.warn(`[TraceExport] uvproject ${s.name}: no normals — UVs left as authored`);
      continue;
    }
    const l = s.getVerticesDataKinds().filter((d) => !Jr.has(d) && !(s.morphTargetManager && qr.test(d)));
    if (l.length) {
      b.warn(`[TraceExport] uvproject ${s.name}: unsupported vertex streams (${l.join(", ")}) — UVs left as authored`);
      continue;
    }
    if (o.length > 1 && !s.getIndices()) {
      b.warn(`[TraceExport] uvproject ${s.name}: multi-material ranges on an unindexed mesh — UVs left as authored`);
      continue;
    }
    s.computeWorldMatrix(!0);
    const f = o.map((d, c) => {
      const u = i[c];
      if (!u) return {
        materialIndex: d.materialIndex,
        indexStart: d.indexStart,
        indexCount: d.indexCount,
        config: null,
        projMatrix: null,
        normalMatrix: null
      };
      const h = u.anchor && !u.anchor.isDisposed() ? u.anchor : s;
      h.computeWorldMatrix(!0);
      const g = new le();
      xt(h, g);
      const w = s.getWorldMatrix().multiply(g);
      return {
        materialIndex: d.materialIndex,
        indexStart: d.indexStart,
        indexCount: d.indexCount,
        config: u.config,
        projMatrix: w,
        normalMatrix: w.clone().invert().transpose()
      };
    });
    n.set(s, { ranges: f });
  }
  return n;
}
function Ee(e) {
  return e instanceof Float32Array ? e : new Float32Array(e);
}
function en(e, t, r) {
  return t === 0 && r === e.length ? e : ArrayBuffer.isView(e) ? e.subarray(t, t + r) : e.slice(t, t + r);
}
function tn(e, t) {
  const r = e.getVerticesData(P.PositionKind), n = e.getVerticesData(P.NormalKind);
  if (!r || !n) return;
  const s = Ee(r), o = Ee(n), a = e.getIndices(), i = t.ranges.length > 1, l = e.getVerticesData(P.UVKind), f = l ? Ee(l) : null, d = [], c = [];
  let u = 0, h = 0;
  for (const [y, S] of t.ranges.entries()) {
    const $ = a ? en(a, S.indexStart, S.indexCount) : null, E = _r(s, o, S.config ? null : f, $);
    let F;
    if (S.config) {
      const U = jr(E.positions, E.normals, S.projMatrix, S.normalMatrix, { scale: S.config.tileSize });
      F = U.uv, b.log(`[TraceExport] uvproject ${e.name}${i ? `#${y}` : ""}: stretch avg ${U.stretchStats.avg.toFixed(3)} max ${U.stretchStats.max.toFixed(3)}`);
    } else F = E.uvs ?? new Float32Array(E.positions.length / 3 * 2);
    const I = Rr(E.positions, E.normals, F), A = Pr({
      positions: E.positions,
      normals: E.normals,
      uvs: F,
      tangents: I
    }), T = A.positions.length / 3;
    d.push({
      positions: A.positions,
      normals: A.normals,
      uvs: A.uvs,
      tangents: A.tangents,
      indices: A.indices
    }), c.push({
      materialIndex: S.materialIndex,
      verticesStart: u,
      verticesCount: T,
      indexStart: h,
      indexCount: A.indices.length
    }), u += T, h += A.indices.length;
  }
  const g = new Float32Array(u * 3), w = new Float32Array(u * 3), M = new Float32Array(u * 2), k = new Float32Array(u * 4), m = new Uint32Array(h);
  for (let y = 0; y < d.length; y++) {
    const S = d[y], $ = c[y];
    g.set(S.positions, $.verticesStart * 3), w.set(S.normals, $.verticesStart * 3), M.set(S.uvs, $.verticesStart * 2), k.set(S.tangents, $.verticesStart * 4);
    for (let E = 0; E < S.indices.length; E++) m[$.indexStart + E] = S.indices[E] + $.verticesStart;
  }
  if (e.setVerticesData(P.PositionKind, g, !0), e.setVerticesData(P.NormalKind, w, !0), e.setVerticesData(P.UVKind, M, !0), e.setVerticesData(P.TangentKind, k, !0), e.setIndices(m, u), i) {
    e.releaseSubMeshes();
    for (const y of c) new pt(y.materialIndex, y.verticesStart, y.verticesCount, y.indexStart, y.indexCount, e);
  }
}
function rn(e, t, r, n) {
  const s = n ? e.getChildren().filter((f) => n.has(f)).length : 0;
  if (s > 0) {
    b.warn(`[TraceExport] scalebake ${e.name}: has ${s} exported child node(s) — skipping the scale fold, so this mesh ships at its rest size`);
    return;
  }
  const o = e.getVerticesData(P.PositionKind);
  if (!o) return;
  const a = new Float32Array(o.length);
  for (let f = 0; f < o.length; f += 3)
    a[f] = o[f] * r.x, a[f + 1] = o[f + 1] * r.y, a[f + 2] = o[f + 2] * r.z;
  e.setVerticesData(P.PositionKind, a, !0);
  const i = e.getVerticesData(P.NormalKind);
  if (i) {
    const f = new Float32Array(i.length);
    for (let d = 0; d < i.length; d += 3) {
      const c = i[d] / r.x, u = i[d + 1] / r.y, h = i[d + 2] / r.z, g = Math.hypot(c, u, h) || 1;
      f[d] = c / g, f[d + 1] = u / g, f[d + 2] = h / g;
    }
    e.setVerticesData(P.NormalKind, f, !0);
  }
  const l = e.getVerticesData(P.TangentKind);
  if (l) {
    const f = new Float32Array(l.length);
    for (let d = 0; d < l.length; d += 4) {
      const c = l[d] * r.x, u = l[d + 1] * r.y, h = l[d + 2] * r.z, g = Math.hypot(c, u, h) || 1;
      f[d] = c / g, f[d + 1] = u / g, f[d + 2] = h / g, f[d + 3] = l[d + 3];
    }
    e.setVerticesData(P.TangentKind, f, !0);
  }
  e.scaling.copyFrom(t), e.computeWorldMatrix(!0);
}
function nn(e) {
  for (const t of e) {
    const r = t.transform;
    !r || r.parent || (r.translation && (r.translation = gr(r.translation) ?? r.translation), r.rotation && (r.rotation = hr(r.rotation) ?? r.rotation));
  }
}
function sn(e) {
  const t = [], r = e.find((n) => !n.transform?.parent);
  for (const n of e) {
    const s = n.transform?.parent;
    s && !an(s, r?.name) && t.push({
      name: n.name,
      parent: s
    });
  }
  return {
    ok: t.length === 0,
    offenders: t
  };
}
function on(e) {
  return e.map((t) => `  • ${t.name} (under ${t.parent})`).join(`
`);
}
function an(e, t) {
  const r = e.startsWith("/") ? e.slice(1) : e;
  return r === "Scene" || !!t && r === t;
}
function cn(e) {
  const t = sn(e), r = lr(e), n = t.ok && r.ok, s = [];
  return t.ok || s.push(`Scene must be flat — nested hierarchy isn't allowed in published Scenes:
${on(t.offenders)}`), r.ok || s.push(`Scene contains assets that aren't published as URLs — upload them as Assets first, then drag them in:
${ir(r.offenders)}`), {
    ok: n,
    flatOffenders: t.offenders,
    srcRefOffenders: r.offenders,
    message: s.join(`

`)
  };
}
function nt(e) {
  const t = (r) => {
    if (Array.isArray(r)) return r.map(t);
    if (r && typeof r == "object") {
      const n = r, s = {};
      for (const o of Object.keys(n).sort()) s[o] = t(n[o]);
      return s;
    }
    return r;
  };
  return JSON.stringify(t(e));
}
function ln(e, t) {
  let r = 0;
  for (const n of e) {
    if (!n.behaviors?.length) continue;
    const s = t(n);
    if (!s?.isSceneReference) continue;
    const o = s.getChildren();
    if (o.length !== 1) continue;
    const a = o[0], i = new Set(a.serializeBehaviors().map(nt));
    i.size !== 0 && (n.behaviors = n.behaviors.filter((l) => i.has(nt(l)) ? (r++, b.log(`[SceneExporter] legacy → 2.1: dropped "${l["@type"]}" from reference "${n.name}" — an import-era copy of the same behavior on the referenced document's root ("${a.name}"). SCENE_ROOT_SPEC §2.3.`), !1) : !0));
  }
  return r;
}
async function Et(e, t) {
  const r = e, n = new Set(Array.isArray(r.files) ? r.files.map((d) => d?.uri) : []), s = /* @__PURE__ */ new Map();
  for (const d of fn(r, n)) {
    const c = t.get(d);
    if (!c) continue;
    let u;
    try {
      u = JSON.parse(await c.text());
    } catch (w) {
      if (w instanceof SyntaxError) continue;
      throw w;
    }
    const h = qt(u);
    if (!Array.isArray(h?.declarations)) continue;
    const g = /* @__PURE__ */ new Map();
    h.declarations.forEach((w, M) => {
      const k = w;
      if (k?.type !== "string" || typeof k.name != "string" || typeof k.value != "string") return;
      const m = k.value.startsWith("./") ? "./" : "", y = k.value.slice(m.length);
      y.startsWith(ut) && n.has(y) && t.has(y) && g.set(M, {
        uri: y,
        prefix: m
      });
    }), s.set(d, {
      raw: u,
      declarations: h.declarations,
      references: g
    });
  }
  const o = [], a = /* @__PURE__ */ new Set(), i = [];
  let l;
  const f = (d, c) => {
    if (a.has(d) || l) return;
    const u = i.indexOf(d);
    if (u !== -1) {
      l = [...i.slice(u), d];
      return;
    }
    i.push(d);
    for (const h of s.get(d)?.references.values() ?? []) {
      const g = t.get(h.uri);
      g && f(h.uri, g);
    }
    i.pop(), a.add(d), o.push([d, c]);
  };
  for (const [d, c] of t) f(d, c);
  return {
    ordered: l ? [] : o,
    ...l ? { cycle: l } : {},
    repoint(d, c, u) {
      const h = s.get(d);
      if (!h) return c;
      let g = !1;
      const w = h.declarations.map((M, k) => {
        const m = h.references.get(k), y = m && u.get(m.uri);
        return !m || y === void 0 || y === m.uri ? M : (g = !0, {
          ...M,
          value: m.prefix + y
        });
      });
      return g ? new Blob([JSON.stringify(Array.isArray(h.raw) ? w : {
        ...h.raw,
        declarations: w
      })], { type: c.type }) : c;
    }
  };
}
function fn(e, t) {
  const r = /* @__PURE__ */ new Set();
  for (const n of Array.isArray(e.nodes) ? e.nodes : []) {
    const s = n?.extras?.trace?.behaviors;
    if (Array.isArray(s))
      for (const o of s) {
        const a = o;
        if (!(a?.["@type"] !== "Properties" || !Array.isArray(a.sheets)))
          for (const i of a.sheets) {
            if (typeof i != "string") continue;
            const l = i.startsWith("./") ? i.slice(2) : i;
            l.startsWith(ut) && t.has(l) && r.add(l);
          }
      }
  }
  return r;
}
async function qn(e, t, r, n) {
  const s = JSON.parse(await e.document.text()), o = await Et(s, e.files);
  if (o.cycle) throw new Error(`Cannot save circular sheet dependencies: ${o.cycle.join(" -> ")}`);
  const a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  try {
    for (const [l, f] of o.ordered) {
      const d = o.repoint(l, f, a), { uri: c } = await r(l, d);
      a.set(l, c), i.set(l, {
        uri: c,
        blob: d
      });
    }
  } finally {
    await n.recordStoredFiles(t, i).catch((l) => {
      b.warn("[uploadFolder] could not record the stored files; the next save sends them again", l);
    });
  }
  return new Blob([JSON.stringify(ht(s, a), null, 2)], { type: Te });
}
async function dn(e, t, r, n, s) {
  const o = await Et(e, t);
  if (o.cycle) return e;
  const a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  for (const [l, f] of o.ordered) {
    const d = o.repoint(l, f, a), c = await s.storedFileFor(n, l, d);
    c === void 0 ? i.set(l, d) : (a.set(l, c), r.add(c));
  }
  for (const l of [...t.keys()]) {
    const f = i.get(l);
    f ? t.set(l, f) : t.delete(l);
  }
  return ht(e, a);
}
var un = /^(?:[a-z][a-z\d+.-]*:|[\\/]{2})/i;
function hn(e) {
  let t;
  try {
    t = JSON.parse(new TextDecoder().decode(e));
  } catch {
    return [];
  }
  if (!t || typeof t != "object") return [];
  const { asset: r, files: n, externalAssets: s, buffers: o, images: a } = t;
  return r?.version !== "2.0" || n || s ? [] : [...Array.isArray(o) ? o : [], ...Array.isArray(a) ? a : []].map((i) => typeof i?.uri == "string" ? i.uri.replace(/^[\u0000-\u0020]+|[\u0000-\u0020]+$/g, "").replace(/[\t\n\r]/g, "") : "").filter((i) => i !== "" && (/^blob:/i.test(i) || !un.test(i)));
}
function gn(e, t, r) {
  if (ft(e) !== "gltf") return;
  const n = hn(t);
  if (n.length === 0) return;
  const s = `glTF model ${e} names separate files (${n.join(", ")}), which a save can't carry. Replace it with a .glb that packs them.`;
  if (r === "throw") throw new Error(s);
  b.warn(`[gltfCompanions] ${s}`);
}
function Me(e, t, r) {
  r?.length && b.warn(`[SceneExporter] ${e} export of "${t}" completed with ${r.length} unresolved reference(s); ` + r.join("; "));
}
function me(e) {
  return e === "trace" || e === "glz" || e === "tracex" || e === "zip";
}
async function pn(e) {
  return JSON.parse(await e.text()).files ?? [];
}
var st = /* @__PURE__ */ new WeakMap(), Qn = class {
  constructor(e) {
    this.traceScene = e;
  }
  async settled(e) {
    const t = (st.get(this.traceScene) ?? Promise.resolve()).then(async () => (await br(this.traceScene), e()));
    return st.set(this.traceScene, t.then(() => {
    }, () => {
    })), t;
  }
  async toTraceBlob(e = {}) {
    return this.settled(() => this.exportTraceFormat(null, e));
  }
  async subtreeToTraceBlob(e, t = {}) {
    return this.settled(() => this.exportTraceFormat(e, t));
  }
  async toGlzBlob(e = {}) {
    return this.settled(() => this.exportBundleFormat(null, e));
  }
  async subtreeToGlzBlob(e, t = {}) {
    return this.settled(() => this.exportBundleFormat({ roots: [e] }, t));
  }
  async toTracexBlob(e = {}) {
    return this.toGlzBlob(e);
  }
  async subtreeToTracexBlob(e, t = {}) {
    return this.subtreeToGlzBlob(e, t);
  }
  async toGltfBlob(e = {}) {
    return this.settled(() => this.writeGltf(e));
  }
  async toGlxfBlob(e = {}) {
    return this.toGltfBlob(e);
  }
  async exportFolder(e = {}) {
    return this.settled(() => this.writeFolder(null, e));
  }
  async subtreeToFolder(e, t = {}) {
    return this.settled(() => this.writeFolder({ roots: [e] }, t));
  }
  async promoteToAsset(e, t = {}) {
    const r = Array.isArray(e) ? [...e] : [e];
    if (r.length === 0) throw new Error("promoteToAsset: nothing selected — a promotion needs at least one object.");
    const n = r.length > 1 || t.alwaysGroup === !0, s = n ? t.name ?? r[0].name : void 0;
    n && b.log(`[SceneExporter] promoteToAsset: grouping ${r.length} object(s) under "${s}" (SCENE_ROOT_SPEC §4 single-root contract) — in the exported document only.`);
    const o = await this.settled(() => this.writeFolder({
      roots: r,
      ...s ? { groupRootName: s } : {}
    }, {
      ...t.onProgress ? { onProgress: t.onProgress } : {},
      ...t.exclude ? { exclude: t.exclude } : {},
      khrInteractivity: t.khrInteractivity,
      destination: "other"
    })), a = Ke(await pn(o.document), {
      ...t.manifest ?? {},
      rejectSceneFolderUrls: !0
    });
    return a.ok || b.warn(`[SceneExporter] promoteToAsset: the asset closure rule (spec §3.2) refuses ${a.offenders.length} manifest entr(ies):
${He(a.offenders)}`), {
      document: o.document,
      files: o.files,
      offenders: a.offenders
    };
  }
  async writeGltf(e = {}) {
    const t = this.traceScene.sceneName, r = this.traceScene._buildDocumentExportData(), n = lt(r.data, r.sceneObjects, e.exclude), s = n.data, o = new Map(s.map((u, h) => [u, n.liveObjects[h]])), a = dt(s, (u) => o.get(u) ?? void 0), i = cn(s);
    if (!i.ok) throw new Error(i.message);
    cr(a);
    const l = this.collectResetRootAssets(null, e.exclude);
    l.size > 0 && b.warn(`[SceneExporter] ${l.size} model(s) in this scene had their GLB root discarded on load (pre-v2 .trace). A standalone .gltf cannot carry that, so those models will be double-transformed by any viewer: ${[...l].join(", ")}`);
    const { BundleExporter: f } = await import("./tracex-exporter-y3cyIU-4.js"), d = await new f({
      sceneName: t,
      includeAssets: !1,
      preserveExternalUris: !0,
      propertySheets: a,
      khrInteractivity: e.khrInteractivity,
      foreignDocument: this.traceScene.foreignDocument
    }).buildFolder(s);
    Me(".gltf", t, d.warnings);
    const c = JSON.stringify(d.document, null, 2);
    return new Blob([c], { type: Te });
  }
  async objectToGlbBlob(e) {
    return this.settled(() => this.writeObjectGlb(e));
  }
  async writeObjectGlb(e) {
    const t = [e, ...e.getDescendants()], r = [], n = Date.now() + at;
    try {
      for (const s of t) r.push(await At(s, n));
      return await this.writePosedObjectGlb(e, t);
    } finally {
      for (const s of r.reverse()) await s();
    }
  }
  async writePosedObjectGlb(e, t) {
    const r = e.transform, n = `${e.name}.glb`, s = /* @__PURE__ */ new Set(), o = [];
    for (const a of [...t].reverse()) {
      if (!Xr(a)) continue;
      const i = new ke(a, s);
      i.hasWork && o.push(i);
    }
    try {
      for (const l of o) l.bake();
      const a = [], i = new Set([r, ...r.getDescendants(!1)].filter((l) => yr(l) ? (a.push(l), !1) : !0));
      return gt(`SceneExporter ${n}`, a), b.log(`Exporting GLB for ${e.name} with ${i.size} nodes`), await vt(this.traceScene.getBabylonScene(), n, i);
    } finally {
      for (const a of [...o].reverse()) a.restore();
    }
  }
  async exportTraceFormat(e, t) {
    const { zipFormat: r = "auto" } = t, n = e ? [e, ...e.getDescendants()] : this.traceScene.getSceneObjects();
    for (const c of n) c.refreshSceneData?.();
    const s = e ? e.name : this.traceScene.sceneName;
    let o = this.traceScene.sourceInfoFile;
    r === "trace" ? o = void 0 : r === "zip" && !o && (o = { traces: [] });
    const a = o ? "zip" : "trace", i = !o, { onProgress: l, imageMarker: f, exclude: d } = t;
    return new rt().exportScene(this.traceScene.getBabylonScene(), s, o, this.traceScene, e ? {
      bundleExternalAssets: i,
      subtreeRoot: e,
      imageMarker: f,
      onProgress: l,
      exclude: d,
      bake: me(a)
    } : {
      bundleExternalAssets: i,
      imageMarker: f,
      onProgress: l,
      exclude: d,
      bake: me(a)
    });
  }
  collectResetRootAssets(e, t) {
    const r = ct(e ? e.roots.flatMap((s) => [s, ...s.getDescendants()]) : this.traceScene.getSceneObjects(), t), n = /* @__PURE__ */ new Set();
    for (const s of r) s._resetAssetTransform && s.src && n.add(s.src);
    return n;
  }
  async prepareFolderExport(e, t = {}, r = "name", n = r === "fetch" ? "drop" : "throw", s) {
    const o = this.traceScene.getBabylonScene(), a = e ? e.groupRootName ?? e.roots[0]?.name ?? this.traceScene.sceneName : this.traceScene.sceneName, i = this.traceScene.resources, l = new rt(), { content: f, assets: d, propertySheets: c, changedPropertySheets: u } = await l.prepareSceneContent(o, a, this.traceScene, e ? {
      bundleExternalAssets: !1,
      subtreeRoots: e.roots,
      ...e.groupRootName ? { groupRootName: e.groupRootName } : {},
      ...t.exclude ? { exclude: t.exclude } : {},
      bake: me("glz"),
      reuseUnchangedBakes: { folderUrl: s }
    } : {
      bundleExternalAssets: !1,
      ...t.exclude ? { exclude: t.exclude } : {},
      bake: me("glz"),
      reuseUnchangedBakes: { folderUrl: s }
    });
    if (Gt(this.traceScene.sceneSourceFormat)) {
      const m = ln(f, (y) => l.liveObjectFor(y));
      m > 0 && b.log(`[SceneExporter] legacy → 2.1 conversion: dropped ${m} import-era reference copy/copies from "${a}" (SCENE_ROOT_SPEC §2.3)`);
    }
    const h = this.collectResetRootAssets(e, t.exclude), g = new Set([...h].map(V)), w = /* @__PURE__ */ new Set([...Object.values(ot).filter((m) => d.has(m)), ...u]);
    for (const m of c.keys()) {
      const y = V(m);
      !u.has(y) && !i.getAsset(m) && i.resolveAssetUrl(m) && d.delete(y);
    }
    const { bakeGlbRootIdentity: M } = h.size > 0 ? await import("./glbRootBake-C5BhDtA1.js") : { bakeGlbRootIdentity: () => {
    } }, { BundleExporter: k } = await import("./tracex-exporter-y3cyIU-4.js");
    return {
      exporter: new k({
        sceneName: a,
        manifest: t.manifest,
        propertySheets: c,
        assetRequiresBake: (m) => h.has(m),
        includeAssets: !0,
        assetName: (m) => i.getAssetName(m),
        onProgress: t.onProgress,
        khrInteractivity: t.khrInteractivity,
        ...e ? {} : { foreignDocument: this.traceScene.foreignDocument },
        unresolvedLocalAssets: n,
        assetResolver: async (m) => {
          const y = (A) => (gn(m, A, n), g.has(V(m)) ? M(A) ?? A : A), S = V(m);
          if (!g.has(S) && !w.has(S)) {
            const A = i.resolveAssetUrl(m) ?? i.getAssetSourceUrl(m);
            if (s && A?.startsWith(s)) return Se;
            if (c.has(m) && r === "name" && !i.getAsset(m) && i.resolveAssetUrl(m)) return Se;
          }
          const $ = d.get(V(m));
          if ($) return y(new Uint8Array(await $.arrayBuffer()));
          const E = i.getAsset(m);
          if (E) return y(new Uint8Array(await E.arrayBuffer()));
          const F = c.get(m);
          if (F && !i.resolveAssetUrl(m)) return new TextEncoder().encode(JSON.stringify(F));
          if (ie(m)) {
            let A;
            try {
              const T = await fetch(m);
              if (!T.ok)
                return b.warn(`[SceneExporter] bundle asset fetch failed (${T.status}): ${m}`), null;
              if (A = await T.arrayBuffer(), it(m, T.headers.get("content-type"), A))
                return b.warn(`[SceneExporter] bundle asset fetch failed (a web page, not an asset): ${m}`), null;
            } catch (T) {
              return b.warn(`[SceneExporter] bundle asset fetch error: ${m}`, T), null;
            }
            return y(new Uint8Array(A));
          }
          if (h.has(m) && se(m)) {
            const A = await fetch(m);
            if (!A.ok) throw new Error(`Legacy GLB root bake failed for ${m}: HTTP ${A.status}`);
            const T = new Uint8Array(await A.arrayBuffer());
            return M(T, { requireValid: !0 }) ?? T;
          }
          const I = i.resolveAssetUrl(m);
          if (I) {
            if (r === "name") return Se;
            const A = await fetch(I);
            if (!A.ok) throw new Error(`Could not fetch folder file "${m}" from ${I} for the archive: ${A.status} ${A.statusText}`);
            return y(new Uint8Array(await A.arrayBuffer()));
          }
          if (n === "throw" && se(m) && f.some((A) => A.src === m)) {
            const A = ft(m), T = or(A)?.dataType === "arraybuffer", U = A !== "gltf" && Qt.has(A);
            if (T || U) {
              const { blob: W } = await this.traceScene.fetchAssetWithProgress(m), L = new Uint8Array(await W.arrayBuffer());
              if (this.traceScene.getBabylonScene().isDisposed) throw ar();
              if (T && sr(L) === void 0) throw new Error(`Hosted scene archive is not a complete ZIP: ${m}`);
              return L;
            }
          }
          return null;
        }
      }),
      content: f,
      sceneName: a
    };
  }
  async exportBundleFormat(e, t = {}) {
    const { exporter: r, content: n, sceneName: s } = await this.prepareFolderExport(e, t, "fetch"), o = await r.export(n);
    if (!o.success) throw new Error(`Bundle export failed: ${o.error}`);
    return Me(".glz", s, o.warnings), new Blob([o.data.buffer], { type: "application/zip" });
  }
  async writeFolder(e, t = {}) {
    const r = t.destination ?? "same", { exporter: n, content: s, sceneName: o } = await this.prepareFolderExport(e, t, r === "other" ? "fetch" : "name", "throw", r === "same" ? t.folderUrl : void 0), a = await n.buildFolder(s);
    if (Me("folder", o, a.warnings), t.manifest) {
      const c = Ke(a.document.files ?? [], t.manifest);
      if (!c.ok) throw new Error(`This scene references files the content model does not allow:
` + He(c.offenders));
    }
    const i = /* @__PURE__ */ new Map();
    for (const [c, u] of a.files) i.set(c, new Blob([u.buffer]));
    const l = r === "same" ? t.folderUrl : void 0, f = this.traceScene.resources, d = l && f.hasStoredFiles(l) ? await dn(a.document, i, a.existing, l, f) : a.document;
    return {
      document: new Blob([JSON.stringify(d, null, 2)], { type: Te }),
      files: i,
      existing: a.existing
    };
  }
};
export {
  on as a,
  kr as c,
  cn as i,
  Jn as l,
  me as n,
  sn as o,
  qn as r,
  rt as s,
  Qn as t,
  Hn as u
};

//# sourceMappingURL=SceneExporter-BNrB8cfd.js.map